/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext, useRef } from "react"; //import the component part of React
import withRouter from "../WithRouter";
import { Navigate } from "react-router-dom";
import { isAuthenticatedCustomer } from "./services/CustomerAuth";
// Common
import FadeIn from "../common/FadeIn";
//Packages
import axios from "axios";
import { Container } from "react-bootstrap";
//Subcomponents
import ClassInfo from "./page-parts/ClassInfo";
import CheckoutForm from "./page-parts/CheckoutForm";
import CouponCodeBlock from "./page-parts/CouponCodeBlock";
import StripeWrapper from "../common/StripeWrapper";
//Loading
import LoadingSpinner from "../LoadingSpinner";
//Context
import { BusinessContextConsumer } from "../BusinessContext";
//Analytics
import TagManager from "react-gtm-module";

const WasWaiting = (props) => {
  // State
  const [classData, setClassData] = useState("");
  const [prorationPrice, setProrationPrice] = useState("");
  const [couponCode, setCouponCode] = useState("");
  // Get the classID and context.
  const selectedParticipant = props.params.participantid;
  const classid = props.params.classid;
  const BusinessContext = useContext(BusinessContextConsumer);
  const { businessID, currencySymbol, currency } = BusinessContext;
  // ref the class ID
  const prevClassId = useRef(); //Reference the previous class ID to ensure new get request if it changes.
  const prevParticipantId = useRef(); // Participant ID
  // Get the class proration data if needed
  useEffect(async () => {
    prevClassId.current = classid; // Assign Refs Value to current load
    prevParticipantId.current = selectedParticipant;

    // Request the Class Data
    const classDataRequest = await axios.get(
      `/api/public_view/class_selected_plus/${businessID}/${classid}/`,
      {
        withCredentials: true,
      }
    );

    // Get the proration price only if necessary
    const returnedData = classDataRequest.data;
    if (returnedData.classData.Prorate && !returnedData.classData.monthStartBilling) {
      const prorationPriceRequest = await axios.get(
        `/api/public_view/class_selected/prorate/${businessID}/${classid}/`,
        {
          withCredentials: true,
        }
      );
      setProrationPrice(prorationPriceRequest.data.prorationPrice);
    }

    //Set the Datalayer Event
    TagManager.dataLayer({
      dataLayer: {
        event: "loggedInClassView",
        lessonType: returnedData.classData.LessonType,
      },
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "view_item",
        ecommerce: {
          items: [
            {
              item_name: returnedData.classData.LessonType,
              price: returnedData.classData.Price,
              item_category: "subscription",
              quantity: 1,
            },
          ],
        },
      },
    });

    return setClassData(returnedData.classData);
  }, [classid, selectedParticipant]); // Run useEffect when the classID changes to get new class data.

  if (classData) {
    return (
      <FadeIn delay={250} duration={450}>
        <Container>
          {!isAuthenticatedCustomer() && <Navigate to='/login/' />}
          <ClassInfo
            prorationPrice={prorationPrice}
            classData={classData}
            currencySymbol={currencySymbol}
          />
          <StripeWrapper>
            <CheckoutForm
              classData={classData}
              selectedParticipant={selectedParticipant}
              currency={currency}
              endpoint='waiting'
              couponCode={couponCode}
            />
          </StripeWrapper>
          <CouponCodeBlock setCouponCode={setCouponCode} />
        </Container>
      </FadeIn>
    );
  } else {
    return <LoadingSpinner />;
  }
};

//Export
export default withRouter(WasWaiting);
